import React from "react";
import PropTypes from "prop-types";

const CalendarIcon = () => (
  <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const InfoIcon = () => (
  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const UpcomingBills = ({ bills, formatAmount, onBillClick }) => {
  if (!bills || bills.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200/50 dark:border-gray-700/50 p-6">
        <div className="flex items-center gap-2 mb-4">
          <CalendarIcon />
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">Facturas por vencer</h3>
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400">No hay facturas por vencer</p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200/50 dark:border-gray-700/50 p-6">
      <div className="flex items-center gap-2 mb-4">
        <CalendarIcon />
        <h3 className="text-lg font-bold text-gray-900 dark:text-white">Facturas por vencer</h3>
      </div>
      <ul className="space-y-4">
        {bills.map((bill) => (
          <li
            key={bill.id}
            className="flex items-center justify-between cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 -mx-2 px-2 py-2 rounded-xl transition-colors"
            onClick={() => onBillClick?.(bill)}
          >
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-gray-900 dark:text-white truncate">{bill.name}</p>
              <p className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2">
                <InfoIcon />
                {bill.daysUntilDue === 0
                  ? "Hoy vence"
                  : bill.daysUntilDue < 0
                    ? `${Math.abs(bill.daysUntilDue)} días vencido`
                    : `${bill.daysUntilDue} días restantes`}
              </p>
            </div>
            <span className="font-bold text-gray-900 dark:text-white ml-2">
              {formatAmount ? formatAmount(bill.amount) : `${typeof bill.amount === "number" ? bill.amount.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : bill.amount}`}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

UpcomingBills.propTypes = {
  bills: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      daysUntilDue: PropTypes.number,
      monthId: PropTypes.string
    })
  ),
  formatAmount: PropTypes.func,
  onBillClick: PropTypes.func
};

export { UpcomingBills };
